import { render, staticRenderFns } from "./DishRanking.vue?vue&type=template&id=5ec14cea&lang=pug"
import script from "./DishRanking.vue?vue&type=script&lang=js"
export * from "./DishRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports